import * as types from "./dadosCadastrais.actionTypes";
import { takeEvery, call, put, select } from "redux-saga/effects";
import dadosCadastraisActions from "./dadosCadastrais.actions";
import dadosCadastraisSelector from "./dadosCadastrais.selectors";
import focusHelper from "@common/helpers/focus.helper";
import apiContador from "@/modules/mobiliario/cadastro/contador/service/contador.service";
import formActions from "@common/store/form/form.actions";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.GET_SUGGESTION_CONTADOR, getSuggestionContador);
  yield takeEvery(types.GET_DATA_OCORRENCIA, getDataOcorrencia);
  yield takeEvery(types.GET_DATA_ABERTURA_CADASTRAL, getDataAberturaCadastral);
  yield takeEvery(
    types.GET_DATA_NASCIMENTO_CADASTRAL,
    getDataNascimentoCadastral
  );
  yield takeEvery(types.SAVE_CONTADOR_CONTRIBUINTE, saveContadorContribuinte);
}

function* getDataOcorrencia(action) {
  const { payload } = action;
  const { name, dados, date } = payload;
  yield onChangeDateTime(name, dados, date);
  yield put(
    dadosCadastraisActions.setDadosCadastrais({ DataOcorrencia: date })
  );
}

function* getDataAberturaCadastral(action) {
  const { payload } = action;
  const { name, dados, date } = payload;
  yield onChangeDateTime(name, dados, date);
  yield put(
    dadosCadastraisActions.setDadosCadastrais({ DataAberturaCadastral: date })
  );
}

function* getDataNascimentoCadastral(action) {
  const { payload } = action;
  const { name, dados, date } = payload;
  yield put(
    dadosCadastraisActions.setDadosCadastrais({ DataNascimentoCadastral: date })
  );
  yield onChangeDateTime(name, dados, date);
}

function* getSuggestionContador(action) {
  const { payload } = action;

  if (payload) {
    yield put(dadosCadastraisActions.setDadosCadastrais({ Contador: payload }));

    if (payload.Email)
      yield put(
        dadosCadastraisActions.setDadosCadastrais({
          EmailContadorCadastral: payload.Email,
        })
      );
  }
}

function* onChangeDateTime(name, dados, date) {
  let minDateValue = new Date("01/01/1753");

  if (date > new Date()) {
    yield resetDataDadosEmpresa(name);

    yield _alert.warningPromise(
      `O valor do campo ${dados.Label}  não deve ser maior que a data atual.`,
      "Data inválida."
    );
    focusHelper.focus(name);
  } else if (date < minDateValue) {
    yield resetDataDadosEmpresa(name);

    yield _alert.warningPromise(
      `O valor do campo ${dados.Label} deve ser maior que a data 01/01/1973.`,
      "Data inválida."
    );
    focusHelper.focus(name);
  } else {
    var data = new Object();
    data[name] = date;
    yield put(dadosCadastraisActions.setDadosCadastrais(data));
  }
}

function* saveContadorContribuinte(action) {
  let state = yield select(dadosCadastraisSelector.dadosCadastrais);
  const result = yield call(apiContador.saveContadorContribuinte, {
    ...state.ContadorContribuinte,
    Situacao: "Ativo",
    Numero: state.ContadorContribuinte.Endereco.Numero,
    Complemento: state.ContadorContribuinte.Endereco.Complemento,
  });
  yield put(formActions.inserted());
  yield put(dadosCadastraisActions.resetContadorContribuinte());
  yield put(dadosCadastraisActions.openModalContador(false));
  yield put(
    dadosCadastraisActions.setDadosCadastrais({
      EmailContadorCadastral: result.data.Email,
      Contador: {
        Id: result.data.Id,
        Exibicao: result.data.Crc + " - " + result.data.Nome,
        Email: result.data.Email,
      },
    })
  );
}

function* resetDataDadosEmpresa(name) {
  name == "DataOcorrencia"
    ? yield put(dadosCadastraisActions.resetDataOcorrencia())
    : yield put(dadosCadastraisActions.resetDataAberturaCadastral());
}
